export default "__VITE_ASSET__En3lx6iS__"